import { qsa } from "@fluorescent/dom";

import { section } from "@/neon";
import { accordions, wrapIframes } from "@/lib/rte";

section("contact", {
  onLoad() {
    this.accordions = accordions(this.container);

    wrapIframes(qsa("iframe", this.container));
  },

  onUnload() {
    this.accordions.destroy();
  },
});
